module.exports = __webpack_public_path__ + "static/media/vts2.b1b9f4f9.jpg";